import { render, staticRenderFns } from "./VideoContentTable.vue?vue&type=template&id=b9f2e044&"
import script from "./VideoContentTable.vue?vue&type=script&lang=js&"
export * from "./VideoContentTable.vue?vue&type=script&lang=js&"
import style0 from "./VideoContentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports